import Konva from 'konva'

// Konva ne teste pas la géométrie d'une forme pour savoir si on clique dessus : il peint
// chaque forme dans un canvas de détection invisible avec une couleur d'identification
// tirée au hasard, puis relit le pixel sous le curseur et cherche à quelle forme cette
// couleur correspond.
//
// Les protections anti-pistage de plusieurs bloqueurs de publicité (Brave, AdGuard,
// certains filtres uBlock) brouillent la relecture des pixels d'un canvas : la couleur
// relue diffère de un ou deux points de celle écrite. La correspondance échoue alors et
// la forme devient insensible au survol comme au clic. Mesuré sur un poste concerné :
// 77 % des couleurs sont altérées, donc environ deux points d'exposition sur trois sont
// muets, au hasard, et le tirage recommence à chaque chargement de page.
//
// Repli : quand la détection par couleur ne reconnaît rien, on cherche la forme par sa
// géométrie. Konva.Node.intersects redessine la forme seule et ne regarde que l'opacité
// du pixel, valeur que le brouillage n'altère pas.

const COULEURS_TEMOINS = [
  [48, 66, 93],
  [1, 62, 226],
  [255, 0, 0],
  [17, 20, 68],
  [141, 233, 156]
]

// Vrai quand le navigateur rend exactement les couleurs écrites. Une seule couleur ne
// suffit pas : le brouillage en laisse passer environ une sur quatre.
function relectureFidele () {
  try {
    const canvas = document.createElement('canvas')
    canvas.width = 64
    canvas.height = 64
    const contexte = canvas.getContext('2d', { willReadFrequently: true })
    if (!contexte) return true
    for (const [rouge, vert, bleu] of COULEURS_TEMOINS) {
      contexte.fillStyle = `rgb(${rouge},${vert},${bleu})`
      contexte.fillRect(0, 0, 64, 64)
      const lu = contexte.getImageData(32, 32, 1, 1).data
      if (lu[0] !== rouge || lu[1] !== vert || lu[2] !== bleu) return false
    }
    return true
  } catch (e) {
    // Canvas indisponible ou lecture refusée : on installe le repli, il ne coûte rien de plus.
    return false
  }
}

// Installe le repli seulement si ce navigateur en a besoin : ailleurs, aucun surcoût et
// aucun changement de comportement.
export default function installerRepliClicKonva () {
  if (relectureFidele()) return false

  const detectionParCouleur = Konva.Layer.prototype.getIntersection

  Konva.Layer.prototype.getIntersection = function (position) {
    const reconnue = detectionParCouleur.call(this, position)
    if (reconnue) return reconnue
    const formes = this.find('Shape')
    // De la forme du dessus vers celle du dessous, comme la détection d'origine.
    for (let i = formes.length - 1; i >= 0; i--) {
      const forme = formes[i]
      if (!forme.isListening() || !forme.isVisible()) continue
      try {
        if (forme.intersects(position)) return forme
      } catch (e) {
        // Forme détachée ou en cours de destruction : on passe à la suivante.
      }
    }
    return null
  }

  console.warn('[canvas] relecture des pixels faussée, probablement par un bloqueur de publicité : détection des points par géométrie')
  return true
}
